import React from "react";
export class KendoMatrixTable extends React.Component<any, any>{
    private grid;
    constructor(props) {
        super(props);
        this.state = {};
    }

    handleDataChange = (data) => {
        this.setState({ visibleValues: data });
    }

    createRows = (series) => {
        var row: any = { seriesName: series.name };
        if (series.tableGroup) {
            row["_tableGroup"] = series.tableGroup
        }
        var index = 0;
        var values = this.props.data.map(function (data) {
            var num = data[series.field];
            var color = data[series.colorField];

            row["value_" + index++] = num;
            if (color) {
                row["color"] = color;
            }

        })
        return row
    }

    createColumns = (data, index): any => {
        if (this.props.settings.categoryAxis) {
            const columnConfig = {
                title: "" + data[this.props.settings.categoryAxis.field],
                field: "value_" + index,
                attributes: { style: "text-align:right;" },
                format: "{0:n}"
            };
            const format = this.props.settings.format;
            if (format) {
                columnConfig.format = '{0:' + format + '}';
            }
            return columnConfig;
        }
        return { title: "..", field: "..." };
    }

    getTemplate = (row) => {
        return '<div style ="width:12px; height:12px; background-color:' + row.color + '"></div>';
    }

    createGridSettings = (data) => {

        var that = this;

        var kendoColumns = null;

        if (!Array.isArray(this.props.data)) {
            kendoColumns = [{ title: "", field: "" }];
        }
        else {
            kendoColumns = [{ title: " ", template: this.getTemplate, width: "25px" },
            {
                title: " ",
                field: "seriesName",
                width: (Number(this.props.settings.firstColumnWidth) - 25) + "px"
            }];
            var index = 0;
            var generatedColumns = this.props.data.map(function (data) { var r = that.createColumns(data, index); index++; return r; });
            kendoColumns.push.apply(kendoColumns, generatedColumns)
        }
        let newRows = [];
        if (this.props.chartSettings && this.props.chartSettings.series) {
            for (var s of this.props.chartSettings.series) {
                if (s.name) {
                    let newRow = this.createRows(s);

                    newRows.push(newRow);
                }
            }
            let sortList = this.props.settings.sortList;

            let sortOrder = {};
            if (sortList && sortList.length > 0) {
                for (let i = 0; i < sortList.length; i++) {
                    sortOrder[sortList[i].name] = i;
                }

                newRows.sort(function (a, b) {
                    return sortOrder[a.seriesName] - sortOrder[b.seriesName];
                });
            }
        }
        let height = this.props.settings.tableHeight ? this.props.settings.tableHeight : 600;

        var gridConfig: any = {
            dataSource: {
                data: newRows,
                pageSize: 200
            },
            //groupable: true,
            height: height,
            sortable: true,
            columns: kendoColumns,
            pageable: {
                refresh: false,
                pageSizes: false,
                buttonCount: 5
            }

        };

        if (this.props.chartSettings.tableGroup) {
            gridConfig.dataSource.group = { field: "_tableGroup", dir: "asc" };
            kendoColumns.push({ field: "_tableGroup", hidden: true, groupHeaderTemplate: "#=value#" })
        }

        return gridConfig;
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.settings != prevProps.settings || this.props.data != prevProps.data) {
            this.grid.setOptions(this.createGridSettings(this.props.data));
        }
    }

    handleExcelExport = (e) => {
        this.grid.saveAsExcel();
        e.preventDefault();
    }

    createToolbar = () => {
        return (
            <div className="k-header k-grid-toolbar" style={{ backgroundColor: "#f3f3f4" }} >
                <a className="k-button k-button-icontext k-grid-excel" href="#" onClick={this.handleExcelExport}>
                    <span className="k-icon k-i-excel"></span>
                </a>
            </div>
        )
    }

    createGrid = (data) => {
        data = data || [];
        var that = this;
        var $rootNode = $(this.refs.grid);

        var grid = $rootNode.kendoGrid(this.createGridSettings(data));

        this.grid = grid.data("kendoGrid");
    }

    componentDidMount() {
        this.createGrid(this.props.data);
    }

    render() {
        var header;
        return (
            <div>
                {this.createToolbar()}
                < div ref="grid" ></div>
            </div>
        );
    }
};